export const displayUUID = (id: string | undefined) => id?.split("-").at(0);
